import { useState, useEffect, useRef } from 'react';

function useDebounce<T>(
	initialValue: T,
	time: number,
): [T, T, React.Dispatch<T>] {
	const [value, setValue] = useState<T>(initialValue);
	const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);
	const timer = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		if (timer.current !== undefined) {
			clearTimeout(timer.current);
			timer.current = undefined;
		};
		
		timer.current = setTimeout(() => {
			setDebouncedValue(value);
			timer.current = undefined;
		}, time);
	}, [value, time]);

	useEffect(() => {
		return () => {
			clearTimeout(timer.current);
		};
	}, []);

	return [debouncedValue, value, setValue];
}

export default useDebounce;